module.exports = __webpack_public_path__ + "media/images/arrow-down-ccd269ab792131ea4b4989c94ac7fb44.svg";